export function getFromToElements(currentPage: string, size: number): string {
  if (currentPage === '1') return `1-${size}`
  const offset = (Number(currentPage) - 1) * 10
  return `${offset + 1}-${offset + size}`
}
